import { createRef, type MutableRefObject } from 'react';
import type { NavigateFunction, To, NavigateOptions } from 'react-router-dom';

export const navigatorRef: MutableRefObject<NavigateFunction | null> = createRef<NavigateFunction | null>();

export const navigate = (to: To, options?: NavigateOptions) => {
  if (navigatorRef.current) {
    (navigatorRef.current as NavigateFunction)(to, options);
  }
};
